import { Injectable, inject } from '@angular/core';
import { Firestore, collection, collectionData, addDoc, doc, updateDoc, query, where, getDocs, writeBatch } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

export interface Owner {
  id?: string;
  name: string;
  email: string;
  phone: string;
  createdAt?: any;
  showTotalDistribution?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class OwnerService {
  private firestore = inject(Firestore);
  private collectionName = 'owners';

  getOwners(): Observable<Owner[]> {
    const col = collection(this.firestore, this.collectionName);
    return collectionData(col, { idField: 'id' }) as Observable<Owner[]>;
  }

  async addOwner(owner: Owner): Promise<void> {
    const col = collection(this.firestore, this.collectionName);
    await addDoc(col, { ...owner, createdAt: new Date() });
  }

  async updateOwner(id: string, owner: Partial<Owner>): Promise<void> {
    const docRef = doc(this.firestore, this.collectionName, id);
    await updateDoc(docRef, owner);
  }

  async deleteOwner(id: string): Promise<void> {
    const batch = writeBatch(this.firestore);

    // 1. Delete associated ownership records
    const ownershipsCol = collection(this.firestore, 'company_ownerships');
    const q = query(ownershipsCol, where('ownerId', '==', id));
    const snapshot = await getDocs(q);
    snapshot.docs.forEach(doc => batch.delete(doc.ref));

    // 2. Delete the owner
    const ownerRef = doc(this.firestore, this.collectionName, id);
    batch.delete(ownerRef);

    await batch.commit();
  }
}